module.exports = __webpack_public_path__ + "static/img/my-class-bg3.8e2eeb58.png";